import actions from '../utils/restActions';
import { customRequest} from '../utils/restUtils';

export const loadPodcasts = () => {
    return (dispatch) => {
	return customRequest(actions.podcasts.index, {}).then((res) => {
	    return dispatch({ type: actions.podcasts.index.status.success, data: res});
	})
    }
}

export const savePodcast = (data) => {
    return (dispatch) => {	   
	return customRequest(actions.podcasts.create, {podcast: data})
    }
}

export const updatePodcast = (data) => {

    return (dispatch) => {
		   
	return customRequest(actions.podcasts.update, {id: data.id, podcast: data})
    }
}

export const removePodcast = (id) => {

    return (dispatch) => {
		   
	return customRequest(actions.podcasts.delete,  {id: id})
    }
}




// WEBPACK FOOTER //
// ./src/actions/Podcasts.js